<template>
  <div class="input-wrapper">
    <label v-if="label" :for="name">
      {{ label }}
      <span v-if="required" class="primary-color">*</span>
      <VTooltip
        v-if="info"
        placement="auto"
        :triggers="['hover']"
        theme="large"
      >
        <i class="bi bi-info-circle" />
        <template #popper>
          <slot name="popper-content"></slot>
        </template>
      </VTooltip>
    </label>
    <div class="input-group" :class="{ disabled }">
      <i v-if="iconL" class="bi iconL" :class="iconL" />
      <Field
        :aria-label="name"
        v-bind="props"
        :value="modelValue"
        :validateOnInput="field_error ? true : false"
        :validateOnModelUpdate="false"
        @input="$emit('update:modelValue', $event.target.value)"
        @keyup.enter="iconButton ? emits('iconClick') : null"
      />
      <i v-if="icon" class="bi" :class="icon" />
      <div class="icon-button" v-else-if="iconButton" @click.stop="emits('iconClick')">
        <slot></slot>
      </div>
    </div>
    <small class="helper-text" v-if="helper" v-text="helper" />
    <ErrorMessage v-if="displayError" :name="name" class="form-error" />
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/style/variables.scss";
.iconL {
  margin: auto 16px !important;
  margin-right: 0 !important;
}

.icon-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  color: var(--secondary-color) !important;
  border-radius: 4px;
  cursor: pointer;

  :deep(svg) {
    width: 20px !important;
    padding: 0px !important;
  }

  &:hover {
    background-color: var(--light-grey-color);
  }
}
</style>

<script setup>
import { Field, useFieldError, ErrorMessage } from "vee-validate";

const emits = defineEmits(["update:modelValue", "iconClick"]);

const props = defineProps({
  disabled: {
    type: Boolean,
  },
  displayError: {
    type: Boolean,
    default: () => false,
  },
  helper: {
    type: String,
  },
  icon: {
    type: String,
    required: false,
  },
  iconL: {
    type: String,
    required: false,
  },
  iconButton: {
    type: String,
    required: false,
  },
  invalid: {
    type: Boolean,
  },
  label: {
    type: String,
  },
  modelValue: {
    type: [String, Array, null],
  },
  name: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
  },
  rules: {
    type: [String, Object],
  },
  type: {
    type: String,
    default: "text",
  },
  info: {
    type: Boolean,
    default: () => false,
  },
  required: {
    type: Boolean,
    default: false,
  },
});

const field_error = useFieldError(props.name);
</script>
